<template>
  <div id="app">
    <RootApp />
  </div>
</template>

<script>
import RootApp from './app/RootApp.vue'

export default {
  name: 'app',
  components: {
    RootApp,
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a.disabled {
  pointer-events: none;
  color: gray;
}
.form-group {
  position: relative;
}

.fonterraFields {
  position: relative;
  border: 3px solid orange;
  border-radius: 5px;
  padding: 10px;
  padding-top: 40px;
  margin-bottom: 10px;
}

.fonterraFields:before {
  position: absolute;
  display: block;
  font-weight: bold;
  top: 0;
  width: 100%;
  content: 'Fonterra Cooperative Difference Report';
  margin-top: 10px;
  margin-bottom: 20px;
  color: orange;
}

.fonterraFields .comment-holder .comment-toggle {
  right: 0;
}

.input-box {
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.input-box .input-box {
  border: none;
}
</style>
